<template>
  <div class="vgm">
    <div class="vgm-content">
      <div class="module-1">
        <p class="title">VGM发送</p>
        <p class="text">操作简单、回执快速、周末及节假日均可发送</p>
        <span class="btn" @click="openQQ">开通咨询</span>
      </div>
      <div class="module" :class="`module-${item.index}`" v-for="(item, i) in module" :key="i">
        <div class="content">
          <p class="title">{{ item.title }}</p>
          <span class="text" v-html="item.content" />
        </div>
      </div>
      <div class="module-explain">
        <div class="nav">如何发送VGM？</div>
        <div class="explain-box">
          <div :class="`explain-box-${item.type}`" v-for="(item, i) in explain" :key="i">
            <img class="number-icon" :src="item.numUrl" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="text" v-html="item.text" />
          </div>
        </div>
      </div>
      <ContactUs />
    </div>
  </div>
</template>
<script>
import ContactUs from '@/components/ContactUs'
import { openQQ, handleScroll } from '@/utils/common.js'
import { ossUrl } from '@/utils/config.js'
export default {
  name: 'cps',
  components: { ContactUs },
  data() {
    return {
      module: [
        {
          index: 2,
          title: '¥5/箱，成本直降',
          content: '每箱仅需5元，直线降低发送成本'
        },
        {
          index: 3,
          title: '支持海量船司',
          content: '支持83家船公司的VGM发送～'
        },
        {
          index: 4,
          title: '高效录单 快速回执',
          content: '支持多种录单模式，「在线录单」、「Excel模版导入」、以及「OpenAPI」对接，助力企业降本增效；'
        },
        {
          index: 5,
          title: 'VGM小程序申报',
          content: '无论电脑端、手机端、随时随地进行VGM 申报，出差在外移动办公更便捷；'
        }
      ],
      explain: [
        {
          type: 'left',
          numUrl: `${ossUrl}/common/introduce/number-1.png`,
          title: '开通VGM权限',
          text: '注册账号并完成企业认证， <br /> 可联系您的专属销售快速开通'
        },
        {
          type: 'center',
          numUrl: `${ossUrl}/common/introduce/number-2.png`,
          title: '录入VGM 信息',
          text: '您可以选择「在线录入」或「Excel模版导入」录入或在小程序上录入 VGM 信息'
        },
        {
          type: 'right',
          numUrl: `${ossUrl}/common/introduce/number-3.png`,
          title: 'PC/手机端查看回执',
          text: '最快5分钟即可接收回执， <br /> 微信小程序随时随地可处理'
        }
      ],
      offetHeight: false
    }
  },
  methods: {
    openQQ
  }
}
</script>
<style lang="scss" scoped>
.vgm {
  width: 100vw;
  overflow-x: hidden;

  .vgm-content {
    width: 100%;
    min-width: 1920px;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .module-1 {
    height: 1080px;
    margin: -60px auto 0;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/vgm-module-1.png');
    background-size: 100%;
    background-repeat: no-repeat;
    text-align: center;

    .title {
      font-size: 68px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #212450;
      line-height: 95px;
      letter-spacing: 1px;
      padding-top: 118px;
    }

    .text {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #212450;
      line-height: 35px;
      letter-spacing: 3px;
      padding-top: 16px;
    }

    .btn {
      width: 180px;
      height: 64px;
      display: block;
      background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/btn.png');
      background-size: 100%;
      margin: 24px auto 0;
      line-height: 64px;
      font-weight: 600;
      color: #ffffff;
      font-size: 24px;
      cursor: pointer;
    }
  }

  .module {
    margin: 120px auto 0;
    background-repeat: no-repeat;

    .content {
      .title {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #212450;
        line-height: 45px;
        letter-spacing: 1px;
      }

      .text {
        display: inline-block;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
        padding-top: 24px;
        text-align: justify;
      }
    }
  }

  .module-2 {
    height: 708px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/vgm-module-2.png');
    background-size: 1408px 708px;
    background-position: 266px;

    .content {
      padding: 300px 0 0 364px;

      .text {
        display: inline-block;
        width: 336px;
        letter-spacing: 1px;
      }
    }
  }

  .module-3 {
    height: 715px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/vgm-module-3.png');
    background-size: 1299px 715px;
    background-position: 314px;

    .content {
      float: right;
      padding: 378px 364px 0 0;

      .text {
        display: inline-block;
        width: 322px;
        letter-spacing: 1px;
      }
    }
  }

  .module-4 {
    height: 682px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/vgm-module-4.png');
    background-size: 1380px 682px;
    background-position: 245px;

    .content {
      padding: 279px 0 0 360px;

      .text {
        width: 280px;
        font-size: 22px;
        letter-spacing: 1px;
      }
    }
  }

  .module-5 {
    height: 691px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/vgm-module-5.png');
    background-size: 1170px 691px;
    background-position: 359px;

    .content {
      float: right;
      padding: 274px 365px 0 0;

      .text {
        display: inline-block;
        width: 295px;
        letter-spacing: 1px;
      }
    }
  }

  .module-explain {
    width: 1180px;
    margin: 119px auto 0;

    .nav {
      text-align: center;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 45px;
      letter-spacing: 2px;
    }

    .explain-box {
      width: 100%;
      margin-top: 48px;
      display: flex;
      justify-content: space-between;

      & > div {
        width: 380px;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 34px 34px 30px;
        color: white;

        .number-icon {
          width: 49px;
          height: 49px;
        }

        .title {
          font-size: 24px;
          padding-top: 16px;
        }

        .text {
          padding-top: 9px;
          font-size: 18px;
          line-height: 25px;
          letter-spacing: 1px;
        }
      }

      .explain-box-left {
        height: 220px;
        background: #3371ff;
      }

      .explain-box-center {
        height: 256px;
        background: #0ddabe;
      }

      .explain-box-right {
        height: 292px;
        background: #ffb817;
      }
    }
  }
}

.fixed {
  position: fixed !important;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
